import React from "react"
import CanvaButton from "./CanvaButton"
import API from "../utils/API"

export default function CanvaConnectButton() {
  const handleCanvaSignIn = () => {
    API.POST("/canva/login", undefined, (response) => {
      window.location.href = response.data.url
    })
  }

  return <CanvaButton title={"Se connecter à Canva"} onClick={handleCanvaSignIn}></CanvaButton>
}
